module.exports = "<svg viewBox=\"0 0 32 32\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\"><path d=\"M10 7H17C21.4183 7 25 10.5817 25 15V28\" stroke=\"currentColor\" stroke-width=\"1.5\" stroke-linecap=\"round\"></path><path d=\"M4 13H15C17.2091 13 19 14.7909 19 17V28\" stroke=\"currentColor\" stroke-linecap=\"round\"></path><path d=\"M28 25L25.3536 27.6464C25.1583 27.8417 24.8417 27.8417 24.6464 27.6464L22 25\" stroke=\"currentColor\" stroke-width=\"1.5\" stroke-linecap=\"round\"></path><circle cx=\"7\" cy=\"7\" r=\"3\" stroke=\"currentColor\" stroke-width=\"1.5\"></circle></svg>"


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/plugin/outside.svg
// module id = xzN6
// module chunks = 1